<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="3.75" y="5.75" width="16.5" height="12.5" rx="1.25" stroke="currentColor" stroke-width="1.5" />
    <path stroke="currentColor" stroke-width="1.5" d="M3.75 9.75h16.5" />
    <path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" d="M7 14.5h3" />
  </svg>
</template>
